const SERVEUR_ERROR_MSG = "Impossible de se connecter au serveur, contactez l'administrateur"
const BASE_URL = "/carnet"

async function apiFetch(url, options = {}) {
    const response = await fetch(url, {
        ...options,
        credentials: 'include',
        headers: {...options.headers, 'X-Pokeland-Request': '1'}
    });
    if (response.status === 401) window.location.assign('/login');
    return response;
}

async function manageResponse(response) {
    if (!response.ok) {
        let errorMessage = await response.text() || "Une erreur s'est produite"
        throw new Error(errorMessage)
    }
    return await response.json();
}

export async function call_drive(url) {
    try {
        const response = await apiFetch(process.env.VUE_APP_API_URL + BASE_URL + url)
        return manageResponse(response)
    } catch (error) {
        console.log(error)
        throw new Error(SERVEUR_ERROR_MSG)
    }

}

export async function delete_drive(url) {
    try {
        const response = await apiFetch(process.env.VUE_APP_API_URL + BASE_URL + url, {
            method: 'DELETE'
        })
        return manageResponse(response)
    } catch (error) {
        console.log(error)
        throw new Error(SERVEUR_ERROR_MSG)
    }

}

export async function post_drive(url, data) {
    try {
        const response = await apiFetch(process.env.VUE_APP_API_URL + BASE_URL + url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: data
        });
        return manageResponse(response)
    } catch (error) {
        console.log(error)
        throw new Error(SERVEUR_ERROR_MSG)
    }
}

// ---------- Commandes ---------

export async function get_commands() {
    return await call_drive('/all');
}

export async function delete_command(id) {
    return await call_drive('/delete/' + id);
}

export async function create_command(form) {
    return await post_drive('/create', JSON.stringify(form));
}

// --------- User ---------------

export async function create_user(form) {
    return await post_drive('/user/create', JSON.stringify(form))
}

export async function delete_user(id) {
    return await call_drive('/user/delete/' + id);
}

export async function update_user(id, form) {
    return await post_drive('/user/update/' + id, JSON.stringify(form));
}

export async function get_all_users() {
    return await call_drive('/user/all');
}

export async function get_all_detail_users() {
    return await call_drive('/user/all/detail');
}

// ---------- Evenements ------------

export async function get_all_events() {
    return await call_drive('/ev/all');
}

export async function get_event(event_id) {
    return await call_drive('/ev/' + event_id);
}

export async function delete_evenement(id) {
    return await delete_drive('/ev/delete/' + id);
}

export async function create_evenement(form) {
    return await post_drive('/ev/create', JSON.stringify(form));
}

export async function add_user_evenement(form) {
    return await post_drive('/ev/add', JSON.stringify(form));
}

export async function delete_user_event(user_id, event_id) {
    const response = await apiFetch(
        `${process.env.VUE_APP_API_URL}${BASE_URL}/ev/${event_id}/users/${user_id}`,
        {method: "DELETE"}
    );
    return manageResponse(response);
}
